import React from "react";
import { Tabs, TabList, Tab, useColorModeValue } from "@chakra-ui/react";
import { ROLE_TAB_OPTIONS } from "./usersListConstants";

/**
 * Tab selector for the users list role filter (Tous / Artistes / Auditeurs Pro).
 * Maps the string filter value to the controlled Chakra tab index.
 * @param {Object} props
 * @param {string} props.value - Current role filter ("all" | "artist" | "auditor")
 * @param {Function} props.onChange - Called with the new role filter value
 * @returns {React.ReactElement}
 */
function UsersRoleTabs({ value, onChange }) {
    const boxBg = useColorModeValue("secondaryGray.100", "whiteAlpha.100");
    const index = Math.max(0, ROLE_TAB_OPTIONS.findIndex((opt) => opt.value === value));
    return (
        <Tabs index={index} onChange={(i) => onChange(ROLE_TAB_OPTIONS[i].value)} variant="soft-rounded"
            colorScheme="brand" mb="12px" bg={boxBg} p="6px" borderRadius="12px">
            <TabList gap="6px">
                {ROLE_TAB_OPTIONS.map((opt) => (
                    <Tab key={opt.value} flex="1" fontSize="0.78rem" fontWeight="600" py="6px">{opt.label}</Tab>
                ))}
            </TabList>
        </Tabs>
    );
}

export default UsersRoleTabs;
